<template>
    <div class="login-main-section bgcolor-e4e9ef col-12 float-l">
        <div class="row">
            <div class="mobile-login-section"></div>
            <div class="middle-login-section bgcolor-ffffff"> <!--login screen-->
                <div class="vvg-logo-img width-full float-l">
  			        <div class="vvg-logo-internal">
  				        <img src="/static/images/login-logo-small.png" alt="Chat Logo">
  			        </div>
  		        </div>
                
                <div class="btm-login-form-main float-l width-full"> <!--login form-->
  			        <h2 class="color-333333 heading-text-22 line-height-26 float-l width-full center font-text-regular ucase m-0"> Sign In </h2>
  			        <p class="color-888888 heading-text-12 line-height-16 float-l width-full center font-text-regular"> Sign in to continue </p>
                    
                    <form>
                        <div class="login-form float-l col-12">
                            <div class="row">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="form-group">
                                            <div class="fl-flex-label">
                                                <input type="text" v-validate="'required'" class="form-control ks-rounded" name="username" v-model="username" id="default-input-rounded" placeholder="Email Address" required>
                                                <!-- <span v-show="errors.has('username')" class="help is-danger">{{ errors.first('username') }}</span> -->
                                            </div>
                                            <span class="help is-danger">{{email_error_msg}}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="row">
                                        <div class="form-group">
                                            <div class="fl-flex-label password-field">
                                                <input :type="pType" v-validate="'required'" class="form-control ks-rounded" name="password" v-model="password" id="default-input-rounded-1" placeholder="Password" required>
                                                <!-- <span v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</span> -->
                                                <a href="javascript:void(0)" v-on:click="hideShow(this)" class="view-icon"> <i class="hi-icon icon-chatview"> </i> </a>
                                            </div>
                                            <span class="help is-danger">{{password_error_msg}}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group btm-login-web">
                                    <!-- <div class="col-6 col-md-6 col-lg-6 col-xl-6 float-l">
                                        <div class="row">
                                            <div class="custom-control custom-checkbox mb_3">
                                                <input type="checkbox" class="custom-control-input" id="customCheck" name="example1">
                                                <label class="custom-control-label" for="customCheck"> Remember Me </label>						      
                                            </div>
                                        </div>
                                    </div> -->

                                    <div class="right-forget-text col-6 col-md-6 col-lg-6 col-xl-6 float-r">
                                        <div class="row">
                                            <a :href="forgot_pass_url" target="_blank" class="color-f5911e heading-text-13 line-height-17 font-medium float-r right width-full"> Forgot your Password? </a>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="help is-danger">{{error_msg_login}}</div>
                                
                                <div class="login-btn width-full float-l">
                                    <button id="loginbtn" type="submit" class="btn btn-primary" v-on:click.prevent="login(this)">
                                        <span class="gradient"></span>  Login 
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="btm-page-link float-r width-full">
                        <!-- <a href="javascript:void(0)" class="color-6d6e70 heading-text-14 line-height-18 font-regular right float-r"> Privacy Policy </a> -->
                        <router-link class="color-6d6e70 heading-text-14 line-height-18 font-regular right float-r" v-bind:to="{name: 'PrivacyPolicy'}"> Privacy Policy </router-link>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {HTTP} from '../../http-common';
    export default {
        name: 'Login',
        data () {
            return {
                username: "",
                password: "",
                login_err_msg: "",
                forgot_pass_url: "",
                pType: 'password',
                error_msg_login: '',
                email_error_msg: '',
                password_error_msg: '',
            }
        },
        mounted: function() {
            var self = this;
            self.checkLocalStorage();
            // process.env.HR_URL
            // "http://localhost:8081/forgotpassword"
            self.forgot_pass_url = process.env.HR_URL + "?identify=" + window.location.href;
            $('.fl-flex-label').flexLabel();

            var elements = $(document).find('select.form-control');
            for (var i = 0, l = elements.length; i < l; i++) {
                var $select = $(elements[i]), $label = $select.parents('.form-group').find('label');
            
                $select.select2({
                    allowClear: false,
                    placeholder: $select.data('placeholder'),
                    minimumResultsForSearch: 0,
                    theme: 'bootstrap',
                    width: '100%' // https://github.com/select2/select2/issues/3278
                });
            
                // Trigger focus
                $label.on('click', function (e) {
                    $(this).parents('.form-group').find('select').trigger('focus').select2('focus');
                });
            
                // Trigger search
                $select.on('keydown', function (e) {
                    var $select = $(this), $select2 = $select.data('select2'), $container = $select2.$container;
                    
                    // Unprintable keys
                    if (typeof e.which === 'undefined' || $.inArray(e.which, [0, 8, 9, 12, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 44, 45, 46, 91, 92, 93, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 123, 124, 144, 145, 224, 225, 57392, 63289]) >= 0) {
                        return true;
                    }

                    // Opened dropdown
                    if ($container.hasClass('select2-container--open')) {
                        return true;
                    }

                    $select.select2('open');

                    // Default search value
                    var $search = $select2.dropdown.$search || $select2.selection.$search, query = $.inArray(e.which, [13, 40, 108]) < 0 ? String.fromCharCode(e.which) : '';
                    if (query !== '') {
                        $search.val(query).trigger('keyup');
                    }
                });

                // Format, placeholder
                $select.on('select2:open', function (e) {
                    var $select = $(this), $select2 = $select.data('select2'), $dropdown = $select2.dropdown.$dropdown || $select2.selection.$dropdown, $search = $select2.dropdown.$search || $select2.selection.$search, data = $select.select2('data');
                
                    // Above dropdown
                    if ($dropdown.hasClass('select2-dropdown--above')) {
                        $dropdown.append($search.parents('.select2-search--dropdown').detach());
                    }

                    // Placeholder
                    $search.attr('placeholder', (data[0].text !== '' ? data[0].text : $select.data('placeholder')));
                });
            }
        },
        methods: {
            checkLocalStorage : function () {
                var self = this;
                var userObj = JSON.parse(localStorage.getItem('user_obj'));

                if (userObj != null && userObj !== "") {
                    self.$router.push('/chat/list');
                    self.showHeader = true;
                } else {
                    const path = "/";
                    if (this.$route.path !== path) 
                        this.$router.push(path);
                }
            },
            login: function() {
                var self = this;
                var error = false;
                self.email_error_msg = '';
                self.password_error_msg = '';

                if(!self.username || self.username == null || self.username == "") {
                    self.email_error_msg = "The username field is required.";
                    error = true;
                }

                if(!self.password || self.password == null || self.password == "") {
                    self.password_error_msg = "The password field is required.";
                    error = true;
                }

                /* this.$validator.validateAll().then((result) => {
                    if (result) { */
                    if(!error) {

                        $('#loginbtn').text("Login...");
                        $("#loginbtn").attr("disabled", true);

                        var fields = {
                            email: self.username,
                            password: self.password
                        };

                        HTTP.post("login", fields)
                                .then(function (data) {

                                    $('#loginbtn').text("Login");
                                    $("#loginbtn").attr("disabled", false);

                                    if (data.status == 200) {

                                        //localStorage.setItem("user_role", data.data.content.role.roles.id);
                                        localStorage.setItem("tkn", data.data.content.api_token);
                                        localStorage.setItem("user_obj", JSON.stringify(data.data.user_obj));
                                        localStorage.setItem("status", data.data.user_obj['status']);
                                        localStorage.setItem("role", data.data.role);
                                        // EventBus.$emit('logged-in', true, data.data.content.user.first_name, data.data.content.user.last_name, data.data.content.user.username);
                                        window.location.href = "/chat/list";
                                        // self.$router.push('/chat/list');
                                    }
                                })
                                .catch(function (error) {
                                    self.error_msg_login = "";
                                    $('#loginbtn').text("Login");
                                    $("#loginbtn").attr("disabled", false);
                                    /* alert(JSON.stringify(error.response.status));
                                    console.log(JSON.stringify(error)); */
                                    if (error.response.status == 0) {
                                        self.error_msg_login = "Remote server can not be reachable";
                                    } else {
                                        if (error.response.data.message) {
                                            self.error_msg_login = error.response.data.message;
                                        }
                                    }
                                })
                        // return;
                    }
                    /* }
                }); */
            },
            hideShow: function() {
                var self = this;
                self.pType = (self.pType == 'password') ? 'text' : 'password';
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/components/Login/Login.vue